export class SubscriberBackendBimerCredentialsModel {
    key: string = "";
    password: string = "";
    clientId: string = "muven-api";
    clientSecret: string = "203d3cc0-1bb9-4813-a251-5eb7f25ca0a0";

    constructor(s?:Partial<SubscriberBackendBimerCredentialsModel>) {
        Object.assign(this, s);
    }
}
